import { useWindowSize } from 'reactApp/hooks/useWindowSize';

const INTEGRATION_WINDOW_SMALL_SIZE = 300;

export const useIsWindowHeightLess = (n: number = INTEGRATION_WINDOW_SMALL_SIZE) => {
    const { windowHeight } = useWindowSize();
    return windowHeight < n;
};
